module.exports = __webpack_public_path__ + "static/img/A-apple1.4115141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-apple1.png
// module id = XcRy
// module chunks = 4